const getNavigatorLanguage = () => {
  const isEnglish = navigator.language.includes('en')

  return isEnglish ? 'en' : navigator.language
}

export default getNavigatorLanguage
